import { render } from "./EditBusiness.vue?vue&type=template&id=6f634c3d&scoped=true"
import script from "./EditBusiness.vue?vue&type=script&lang=js"
export * from "./EditBusiness.vue?vue&type=script&lang=js"

import "./EditBusiness.vue?vue&type=style&index=0&id=6f634c3d&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f634c3d"]])

export default __exports__